<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>기부후원 단체 관리</strong></div>
			<h2 class="h_sub">기부후원 단체 등록</h2>
		</div>

    <DonationGroupManageCreateForm/>
  </div>
</template>

<script>
import DonationGroupManageCreateForm from '@/components/admin/board/DonationGroupManageCreateForm.vue';

export default {
  components: {
    DonationGroupManageCreateForm
  }
}
</script>
<style lang="">
    
</style>